export function getDatenqualitaet(data: any[], datenqualitaet_emissionsfaktor?: number): number {
    data = data || [];
    if (!data.length) {
        return null;
    }
    let sumAvg: number = 0;
    let sumWert: number = 0;

    for (let { bewertung, datenherkunft, emissionsfaktor, wert } of data) {
        if (typeof emissionsfaktor === 'undefined') {
            emissionsfaktor = datenqualitaet_emissionsfaktor || 3;
        }

        if (typeof wert !== 'number' || datenherkunft < 1 || emissionsfaktor < 1 || bewertung < 1) {
            return null;
        }
        sumAvg += ((datenherkunft + emissionsfaktor + bewertung) / 3) * wert;
        sumWert += wert;
    }
    const res = sumWert ? sumAvg / sumWert : null;
    return res;
}
